import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { createCart } from '../../../../client/api/cart'
import { Cart } from '../../../../client/types/cart'
import { useClearUrlParams } from './useClearUrlParams'

interface UseMarketplaceCartProps {
  cartGuid: string | null
  updateCartCache: (cart: Cart) => void
}

export const useMarketplaceCart = ({
  cartGuid,
  updateCartCache
}: UseMarketplaceCartProps) => {
  const { search } = useLocation()
  const clearUrlParams = useClearUrlParams()
  const hasCreatedMarketplaceCart = useRef(false)

  useEffect(() => {
    const queryParams = new URLSearchParams(search)
    const utm_source = queryParams.get('utm_source')
    const isMarketplace = utm_source === 'discover_page'

    if (isMarketplace && !cartGuid && !hasCreatedMarketplaceCart.current) {
      hasCreatedMarketplaceCart.current = true

      createCart({ orderSource: 'CATERING_MARKETPLACE' })
        .then((cart: Cart) => {
          updateCartCache(cart)
          // Clean URL after cart is persisted
          clearUrlParams(['utm_source'])
        })
        .catch((error) => {
          console.error('Failed to create marketplace cart:', error)
          hasCreatedMarketplaceCart.current = false
          // Still clean URL even if cart creation failed
          clearUrlParams(['utm_source'])
        })
    } else if (isMarketplace && cartGuid) {
      // If we already have a cart, just clean the URL
      clearUrlParams(['utm_source'])
    }
  }, [cartGuid, updateCartCache, clearUrlParams, search])
}
